


export const GetSchedule = async ({ departure, arrival }) => {

    const res = await fetch(`https://booking.sila-avia.ru/websky/json/get-schedule-period?departure=${departure}&arrival=${arrival}`, {
        method: 'GET',
    });

    return res.json();

}
